//Models 
import HomeModel from './model.js';
import AppModel from '../App/model.js';
import FiltersModel from '../_filters/model.js';
import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

// update home page map
const updateHomePageMap = HomeModel.updateHomePageMap;
// update the query string based on the selected filters
const updateQueryString = FiltersModel.updateQueryString;
// update the path params based on the [ adType, locations, realEstateTypes ]
const updateRealEstateSearchPathParams = FiltersModel.updateRealEstateSearchPathParams;
// show alert message
const showAlert = AppModel.showAlert;

let CARD_W = 350; //fixed card width
let GAP = 20; // spaceBetween

// Pad the end so the last 350px card can fully snap into view
function adjustOffsets(sw) {
  const w = sw.width;
  const slidesCount = sw.slides.length;

  // how many cards can we show per view
  let perView;
  if (sw.params.slidesPerView === 'auto') {
    perView = Math.max(1, Math.floor((w + GAP) / (CARD_W + GAP)));
  } else {
    perView = sw.params.slidesPerView;
  }

  // do all slides fit in the viewport?
  const totalWidth = slidesCount * CARD_W + (slidesCount - 1) * GAP;
  const allFit = totalWidth <= w || slidesCount <= perView;

  // show/hide nav
  const $nav = $('.custom-button-prev, .custom-button-next');
  $nav.toggle(!allFit);

  const used = perView * CARD_W + (perView - 1) * GAP;
  let leftover = Math.max(0, w - used);
  if (leftover < 50) leftover = 0;

  sw.params.slidesOffsetAfter = leftover;
  sw.update();
}

// update swiper navigation buttons state
function updateNav(swiper) {
    const $prev = $('.custom-button-prev');
    const $next = $('.custom-button-next');

    // if content fits in viewport, Swiper is "locked"
    const showNav = !swiper.isLocked;

    $prev.toggle(showNav);
    $next.toggle(showNav);

    if (!showNav) return; // nothing to update

    $prev.prop('disabled', swiper.isBeginning);
    $next.prop('disabled', swiper.isEnd);
    $prev.toggleClass('is-disabled', swiper.isBeginning);
    $next.toggleClass('is-disabled', swiper.isEnd);
}

$(document).ready(function(){

    const viewPort = $(window).width();

    
    if(viewPort < 430){ // adjust card width for small viewports
        CARD_W = 300;
    }else if(viewPort < 1440){ // adjust gap for medium viewports
        GAP =16;
    }
    
    // initialize real estate ads swiper
    new Swiper(".properties-slider", {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16, 
        // centeredSlides: false,
        centeredSlidesBounds: true,      // keeps first/last nicely aligned
        centerInsufficientSlides: false,  // center if fewer slides than viewport
        watchOverflow: true,             // disable if not enough slides to scroll
        modules: [Navigation],
        navigation: {
            nextEl: '.custom-button-next',
            prevEl: '.custom-button-prev',
        },
        on: {
            init() { adjustOffsets(this); updateNav(this); },
            resize() { adjustOffsets(this); },
            slideChange() { updateNav(this); },
            update() { updateNav(this); },
        },
        breakpoints: {
            430: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                spaceBetween: 20,
                slidesPerView: 3
            },
            1280: {
                spaceBetween: 20,
                slidesPerView: 4
            }
        }
    });

    // validate filters before submitting the form and modify the query string
    $('#search-page-filters').on('submit', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $maxSpace = $('#space_max');
        const $maxPrice = $('#price_max');
        const baseUrl = $form.attr('action');
        // const saveFiltersUrl = $form.data('save-filters')
        const { urlQueryString } = updateQueryString($form);
    
        // validate the price and space filters
        if (parseInt($maxPrice.val()) < parseInt($('#price_min').val())) {
            showAlert($maxPrice.data('error-msg'), 'error');
            return;
        }
        
        if (parseInt($maxSpace.val()) < parseInt($('#space_min').val())) {
            showAlert($maxSpace.data('error-msg') , 'error');
            return;
        }

        window.location.href = updateRealEstateSearchPathParams(baseUrl, $form) + '?' + urlQueryString;

        // $.ajax({
        //     headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
        //     url: saveFiltersUrl,
        //     type: 'POST',
        //     data: formQueryString,
        //     dataType: 'json',
        //     context: this,
        //     success: function (response) {
        //         // Redirect to the search page
        //         if(response.status === 200){
        //             window.location.href = updateRealEstateSearchPathParams(baseUrl, $form) + '?' + urlQueryString;
        //         }

        //     },
        //     error: function() {
        //         console.error('Error saving filters');  
        //     }
        // });
    });

    //update home page map when user change the ad type
    $('input[name="ad_type"]').on('change',function(){
        if($('#search-page-filters').hasClass('home')){
            updateHomePageMap();
        }
    });

    $('#homepage-map .map-region').on({
        click: function () {
            const target = $(this);
            var regionName = target.data('region-name');
            
            // if(target.hasClass('map-region')) {
            //     regionName = target.data('region-name');
            // }else{
            //     regionName = target.siblings('.map-region').data('region-name');
            // }
        
            if (typeof regionName !== 'undefined' && regionName != '') {
                const $form = $('#search-page-filters');
                const baseUrl = $form.attr('action');
                const location = regionName.toLowerCase();
                // remove user input locations and append region location input
                $form.find('input[name="locations[]"]').remove();
                $form.append(`<input type="hidden" name="locations[]" value="${location}">`);

                const { urlQueryString } = updateQueryString($form)
                window.location.href = updateRealEstateSearchPathParams(baseUrl, $form) + '?' + urlQueryString + '&map_view=true';
            }
        },
    
        // mouseenter: function () {
        //     const target = $(this);
        //     if(!target.hasClass('map-region')) {
        //         const regionElement = target.siblings('.map-region');
        //         regionElement.css({
        //             'stroke-width': 1,
        //             'stroke': '#389efc'
        //         });
        //     }
        // },
        // mouseleave: function () {
        //     const target = $(this);
        //     if(!target.hasClass('map-region')) {
        //         const regionElement = target.siblings('.map-region');
        //         regionElement.removeAttr('style');
        //     }
        // }
    });
});
